export default "__VITE_ASSET__CLFvLbyo__"